/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


const interval = setInterval(() => {
    const swiperContainer = document.querySelector('[slidesperview="2"] media-carousel-slider');
    
    // Check if Swiper instance exists on the container
    if (swiperContainer && swiperContainer.swiper) {
        // Access the Swiper instance and update its parameters
        swiperContainer.swiper.params.slidesPerView = 2; // Default: Show 2 slides at a time
        swiperContainer.swiper.params.slidesPerGroup = 2; // Default: Move 2 slides at a time
        
        // Add breakpoints for responsiveness
        swiperContainer.swiper.params.breakpoints = {
            768: {
                slidesPerView: 2, // For screen width >= 768px
                slidesPerGroup: 2,
            },
            0: {
                slidesPerView: 1, // For screen width < 768px
                slidesPerGroup: 1,
            }
        };

        swiperContainer.swiper.update(); // Apply changes

        clearInterval(interval); // Stop checking once it's updated
    }
}, 200); // Check every 200ms
